import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { WhatsNewService } from '../../services/whats-new.service';
import { WhatsNewItem } from '../../data/whats-new.data';
import { VERSION_INFO } from '../../../version';

@Component({
  selector: 'app-whats-new-dialog',
  templateUrl: './whats-new-dialog.component.html',
  styleUrls: ['./whats-new-dialog.component.scss'],
  imports: [CommonModule, DialogModule, ButtonModule]
})
export class WhatsNewDialogComponent implements OnInit {
  visible = false;
  whatsNewData: WhatsNewItem[] = [];
  currentVersion = VERSION_INFO.version;
  loading = true;

  constructor(private whatsNewService: WhatsNewService) {}

  ngOnInit(): void {
    this.loadWhatsNew();
  }

  loadWhatsNew(): void {
    this.loading = true;
    this.whatsNewService.getWhatsNew().subscribe({
      next: (data) => {
        this.whatsNewData = data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Failed to load What\'s New:', error);
        this.whatsNewData = [];
        this.loading = false;
      }
    });
  }

  show(): void {
    this.visible = true;
    // Mark as seen when dialog is opened
    this.whatsNewService.markAsSeen(this.currentVersion);
  }

  hide(): void {
    this.visible = false;
  }

  formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',
      timeZone: 'UTC'  // Force UTC interpretation to prevent timezone shift
    });
  }
}

